module.exports = __webpack_public_path__ + "static/media/onkar_bhawat.a242c72e.png";